import { render, staticRenderFns } from "./packing.vue?vue&type=template&id=05960fcc&"
import script from "./packing.vue?vue&type=script&lang=ts&"
export * from "./packing.vue?vue&type=script&lang=ts&"
import style0 from "./packing.vue?vue&type=style&index=0&id=05960fcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports